import { View } from "react-native";
import OpacityView from "src/components/OpacityView";
import ProfilePicture from "src/components/ProfilePicture";
import Touchable from "src/components/Touchable";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { radiusMedium } from "src/styles/radius";
import { paddingLarge, paddingMedium, paddingXL } from "src/styles/spacing";
import { AnimatePresence, Text } from "src/swsh-native";

const DisplayTagSuggestions = ({
	users,
	onPress,
}: {
	users: {
		userId: string;
		firstName: string;
		lastName: string;
	}[];
	onPress?: (args: { firstName: string; lastName: string; userId: string }) => void;
}) => {
	const { theme } = useStyle();

	return (
		<AnimatePresence>
			{users.length > 0 && (
				<View
					pointerEvents="box-none"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						height: 0,
						width: "100%",
					}}
				>
					<OpacityView
						testID="CommentSuggestions"
						style={{
							position: "absolute",
							left: paddingXL,
							bottom: 0,
							backgroundColor: color.BackgroundCard[theme],
							borderRadius: radiusMedium,
							overflow: "hidden",
							shadowColor: "#000000",
							shadowOpacity: 0.1,
							shadowRadius: 10,
						}}
					>
						{users.map((user) => (
							<Touchable
								key={user.userId}
								testID="CommentSuggestionUser"
								style={{
									flexDirection: "row",
									alignItems: "center",
									paddingVertical: paddingMedium,
									paddingHorizontal: paddingLarge,
									columnGap: paddingMedium,
								}}
								onPress={() => {
									onPress?.({
										firstName: user.firstName,
										lastName: user.lastName,
										userId: user.userId,
									});
								}}
							>
								<ProfilePicture userId={user.userId} size={14} touchable={false} />
								<Text semibold small>
									{user.firstName} {user.lastName}
								</Text>
							</Touchable>
						))}
					</OpacityView>
				</View>
			)}
		</AnimatePresence>
	);
};
export default DisplayTagSuggestions;
